import i18n, { LocalKeys } from "utilities/i18n";
import { topicKeys } from "Constants";

export const getInsightTitleTranslation = (topicId: string) => {
  const key: LocalKeys = `INSIGHT_TOPIC_${topicKeys[topicId]}_TITLE` as const;
  return i18n.t(key);
};

export const getInsightDescriptionTranslation = (topicId: string) => {
  const key: LocalKeys = `INSIGHT_TOPIC_${topicKeys[topicId]}_DESCRIPTION` as const;
  return i18n.t(key);
};
